import { createSlice } from '@reduxjs/toolkit';
import { TUTORIAL_STEPS } from '../tutorialSteps';

// Состояние туториала живёт в localStorage (per user): { status, done }.
//   status: 'idle'   — туториал не запускался (старые игроки) — ничего не показываем
//           'active' — идёт; текущий шаг = первый из TUTORIAL_STEPS, которого нет в done
//           'done'   — пройден или пропущен
const STORAGE_PREFIX = 'datum.tutorial.v1.';

export function loadTutorialState(userId) {
  try {
    const raw = window.localStorage.getItem(STORAGE_PREFIX + userId);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function saveTutorialState(userId, { status, done }) {
  try {
    window.localStorage.setItem(STORAGE_PREFIX + userId, JSON.stringify({ status, done }));
  } catch {
    // приватный режим / квота — туториал просто не переживёт перезапуск
  }
}

const initialState = {
  userId: null,
  status: 'idle',
  done: [],
};

const findCurrentStep = (state) =>
  state.status === 'active' ? TUTORIAL_STEPS.find((s) => !state.done.includes(s.id)) || null : null;

const markDone = (state, stepId) => {
  if (!state.done.includes(stepId)) state.done.push(stepId);
  if (!findCurrentStep(state)) state.status = 'done';
};

const tutorialSlice = createSlice({
  name: 'tutorial',
  initialState,
  reducers: {
    hydrateTutorial: (state, action) => {
      const { userId, saved } = action.payload;
      if (state.userId === userId) return;
      state.userId = userId;
      state.status = saved?.status || 'idle';
      state.done = Array.isArray(saved?.done) ? saved.done : [];
    },
    // Вызывается при завершении онбординга (первый вход)
    startTutorial: (state, action) => {
      state.userId = action.payload ?? state.userId;
      state.status = 'active';
      state.done = [];
    },
    completeTutorialStep: (state, action) => {
      const current = findCurrentStep(state);
      if (current && current.id === action.payload && current.completeOn === 'click') markDone(state, current.id);
    },
    // Сигнал из кода игры (например, 'spin'): закрывает текущий шаг с completeOn: { event }
    tutorialEvent: (state, action) => {
      const current = findCurrentStep(state);
      if (current && current.completeOn?.event === action.payload) markDone(state, current.id);
    },
    skipTutorial: (state) => {
      if (state.status === 'active') state.status = 'done';
    },
  },
});

export const selectTutorialStep = (state) => findCurrentStep(state.tutorial);

export const {
  hydrateTutorial,
  startTutorial,
  completeTutorialStep,
  tutorialEvent,
  skipTutorial,
} = tutorialSlice.actions;

export default tutorialSlice.reducer;
